// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ListChevronsDownUp as RawListChevronsDownUp } from "lucide-react";
export const ListChevronsDownUp = /* @__PURE__ */ createIcon(RawListChevronsDownUp, "ListChevronsDownUp", 2);
